import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Import Google Fonts */
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Lato:wght@300;400;500;600;700&display=swap');

  /* CSS Reset */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: ${props => props.theme.typography.fontFamily.body};
    background-color: ${props => props.theme.colors.background.main};
    color: ${props => props.theme.colors.text.primary};
    font-size: ${props => props.theme.typography.fontSize.base};
    line-height: 1.6;
    overflow-x: hidden;
    
    @media (min-width: ${props => props.theme.breakpoints.xl}) {
      font-size: ${props => props.theme.typography.fontSize.lg};
    }
    
    @media (min-width: ${props => props.theme.breakpoints['2xl']}) {
      font-size: ${props => props.theme.typography.fontSize.xl};
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.typography.fontFamily.display};
    font-weight: ${props => props.theme.typography.fontWeight.bold};
    line-height: 1.2;
    margin-bottom: ${props => props.theme.spacing.md};
  }

  h1 {
    font-size: ${props => props.theme.typography.fontSize['5xl']};
    
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      font-size: ${props => props.theme.typography.fontSize['7xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints.lg}) {
      font-size: ${props => props.theme.typography.fontSize['8xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints.xl}) {
      font-size: ${props => props.theme.typography.fontSize['9xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints['2xl']}) {
      font-size: ${props => props.theme.typography.fontSize['10xl']};
    }
  }

  h2 {
    font-size: ${props => props.theme.typography.fontSize['4xl']};
    
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      font-size: ${props => props.theme.typography.fontSize['5xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints.lg}) {
      font-size: ${props => props.theme.typography.fontSize['6xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints.xl}) {
      font-size: ${props => props.theme.typography.fontSize['7xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints['2xl']}) {
      font-size: ${props => props.theme.typography.fontSize['8xl']};
    }
  }

  h3 {
    font-size: ${props => props.theme.typography.fontSize['2xl']};
    
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      font-size: ${props => props.theme.typography.fontSize['3xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints.lg}) {
      font-size: ${props => props.theme.typography.fontSize['4xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints.xl}) {
      font-size: ${props => props.theme.typography.fontSize['5xl']};
    }
  }
  
  h4 {
    font-size: ${props => props.theme.typography.fontSize.xl};
    
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      font-size: ${props => props.theme.typography.fontSize['2xl']};
    }
    
    @media (min-width: ${props => props.theme.breakpoints.lg}) {
      font-size: ${props => props.theme.typography.fontSize['3xl']};
    }
  }
  
  p {
    @media (min-width: ${props => props.theme.breakpoints.xl}) {
      font-size: ${props => props.theme.typography.fontSize.lg};
    }
    
    @media (min-width: ${props => props.theme.breakpoints['2xl']}) {
      font-size: ${props => props.theme.typography.fontSize.xl};
    }
  }


  a {
    color: ${props => props.theme.colors.primary.main};
    text-decoration: none;
    transition: ${props => props.theme.transitions.default};
    
    &:hover {
      opacity: 0.8;
    }
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
  }

  /* Container utility */
  .container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.lg};
    
    @media (min-width: ${props => props.theme.breakpoints.lg}) {
      padding: 0 ${props => props.theme.spacing['2xl']};
    }
  }

  /* Screen reader only */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  /* Focus visible styles */
  *:focus-visible {
    outline: 2px solid ${props => props.theme.colors.primary.main};
    outline-offset: 2px;
  }
`;

export default GlobalStyles;
